import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const QuestionDbService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 题库分页
     */
    questionDbPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'questionDb/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    questionDbList({ commit }) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'questionDb/list').then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
    * 根据主键获得题库
    */
    questionDbGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'questionDb/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得题库详情
    */
    questionDbGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'questionDb/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 题库保存
     */
    questionDbSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'questionDb/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 题库更新
     */
    questionDbUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'questionDb/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 题库删除
     */
    questionDbRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'questionDb/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default QuestionDbService
